module.exports = __webpack_public_path__ + "static/media/Anushka_More.75a0c980.jpg";